import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import MDButton from "../../MDButton";
import { CircularProgress } from "@mui/material";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { storeEquipment } from "../../../actions/equipments/equipments";
import ModalSelectOperator from "../../Modal/Operator/OperatorSelectModal";
import ModalOperator from "../../Modal/Operator/OperatorModal";
import ModalOperatorForEquipment from "../../Modal/Operator/OperatorModalForEequipment";
import { Button } from "@heroui/button";

export default function CreateEquipmentComponent(){
    const router = useNavigate();
    const [pending , setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [isOptionSelected, setIsOptionSelected] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [driver, setDriver] = useState([]);
    const [title, setTitle] = useState("");

    async function storeNewEquipment(e){
        e.preventDefault();
        const jsonData = {
            name: title,
            operators: driver.map((d) => d.id)
        };
        setLoading(true);
        const state = await storeEquipment(jsonData);
        setLoading(false);
        if(state.status === "success"){
            toast.success(state.message);
            router('/equipments');
        }else{
            toast.error(state.message);
        }
    }

    return (
      <>
          <ModalOperatorForEquipment setShowModal={(state)=>{
              setOpenModal(state)
          }} setData={""} onSelectedIdsChange={(data)=>{
              setDriver(data);
          }} showModal={openModal} />
          <DashboardLayout>
              <div className="flex flex-col gap-9">
                  <form onSubmit={storeNewEquipment}>
                      <div
                        className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
                          <div className="border-b border-stroke px-6 py-4 dark:border-strokedark">
                              <h3 className="font-medium text-black dark:text-white">
                                  ثبت تجهیز بارگیری
                              </h3>
                          </div>
                          <div className="flex flex-col gap-5 p-6">
                              <div className="flex flex-wrap gap-5">
                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          عنوان
                                      </label>
                                      <input
                                        type="text"
                                        name='name'
                                        onChange={(e)=>setTitle(e.target.value)}
                                        placeholder="..."
                                        className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                      />
                                  </div>
                                  <div className={"flex-1"}>
                                      <label className="block text-sm font-medium text-gray-700 mb-2">انتخاب اپراتور</label>
                                      <div onClick={()=>{
                                          setOpenModal(true);
                                      }} className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring focus:ring-blue-300">
                                          {driver.length <= 0 ? '--' : driver.map((d) => d.name).join(" - ")}
                                      </div>
                                  </div>
                              </div>

                              <div className={"flex mt-7 w-1/5"}>
                                  <Button isLoading={pending} type={"submit"} variant="gradient"
                                          className="!bg-blue-500 !py-5 hover:bg-blue-600 text-white w-full">
                                      ایجاد
                                  </Button>
                              </div>
                          </div>
                      </div>
                  </form>
              </div>
          </DashboardLayout>
      </>
    );
}